import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import SuccessPage from "./components/SuccessPage";
const root = ReactDOM.createRoot(document.getElementById("root"));

const router = createBrowserRouter([
  {
    path: "/threem-ui",
    element: <App />,
  },
  {
    path: "/threem-ui/success",
    element: <SuccessPage />,
  },
]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
